const BOTTOM_MODAL_NOTICE_TYPE = {
  TEXT: 'TEXT',
  IMAGE: 'IMAGE',
  FULL: 'FULL',
  AD: 'AD'
};
const CENTER_MODAL_TYPE = {
  NOTICE: 'NOTICE',
  CONFIRM: 'CONFIRM'
};
const BOTTOM_TOP_MODAL_TYPE = {
  BOTTOM: 'BOTTOM',
  TOP: 'TOP'
};
const NONE_MODAL_TYPE = 'NONE';
const CENTER_MODAL_OVERFLOW_HEIGHT = 440;
const MODAL_ID = {
  BOTTOM_MODAL_NOTICE: 'BOTTOM_MODAL_NOTICE',
  CENTER_MODAL: 'CENTER_MODAL'
};
const MODAL_CATEGORY = {
  BOTTOM_NOTICE: 'BOTTOM_NOTICE',
  CENTER: 'CENTER',
  BOTTOM: 'BOTTOM',
  TOP: 'TOP'
};

export { BOTTOM_MODAL_NOTICE_TYPE, BOTTOM_TOP_MODAL_TYPE, CENTER_MODAL_OVERFLOW_HEIGHT, CENTER_MODAL_TYPE, MODAL_CATEGORY, MODAL_ID, NONE_MODAL_TYPE };
